import { I } from '@angular/cdk/keycodes';
import { ChangeDetectorRef, Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ADDITIONAL_DETAILS, PAYMENTTYPE, REFERENCE_KEY } from '@common/constants';
import {ResultPageService } from '@common/services';
import { BaseFpxFormComponent } from '@common/utils';
import { PopupComponent } from 'src/app/common/components/popup/popup.component';
import { BeneficiaryListHelper, BeneficiaryListState } from './services/beneficiary-list.helper';
import { environment } from 'src/environments/environment';
import { RetailStock } from 'src/app/retail-common.service';
import { toVw, toVwU } from 'src/app/utils/ux';
import { ServiceStock } from 'src/app/service-stock.service';
import { gsap } from "gsap";
import { BeneficiaryService } from 'src/app/services/beneficiary/beneficiary.service';
import { CommonService } from 'src/app/common.service';
import { TranslateService } from '@ngx-translate/core';

declare let $: any;
@Component({
  selector: 'app-beneficiary-list',
  templateUrl: './beneficiary-list.component.html',
  styleUrls: ['./beneficiary-list.component.scss']
})
export class BeneficiaryListComponent extends BaseFpxFormComponent<BeneficiaryListHelper, BeneficiaryListState> {
  paymentType: any;
  beneGrpList: any = [];
  fromAccountNumber: any;
  data: any;
  popupMode: boolean = false;
  additionalDetails: any;
  favBeneList: any;
  swiftBeneList: any;
  sepaBeneList: any;
  intbtBeneList: any;
  allBeneList: any;
  achBeneList: any;
  isTransfer:boolean = false;

  constructor(
    _formBuilder: FormBuilder,
    private _router: Router,
    public _beneficiaryListHelper: BeneficiaryListHelper,
    public _beneficiaryService: BeneficiaryService,
    private dialogRef: MatDialogRef<PopupComponent>,
    private retailStock: RetailStock,
    public services: ServiceStock,
    protected translate: TranslateService,
    public _commonService: CommonService) {
    super(_formBuilder, _router, _beneficiaryListHelper);
  }

  override doPreInit() {
    this.initializeForm();
  }

  initializeForm() {
    this.additionalDetails = this.getRoutingParam(ADDITIONAL_DETAILS);

    this._beneficiaryListHelper.transferService.setTitle(['home', 'transfers'], true, this.translate.instant('PAYMENTDETAILS.manageTitle'));

    if (this._commonService.isMobile()) {
      this.retailStock.headerRequired = false;
      this.retailStock.footerRequired = false;
    }

    if (this.data?.screenData) {
      this.popupMode = true;
      this.paymentType = this.data.screenData.paymentType;
    }
    else {
      this.popupMode = false;
      if(this.getRoutingParam(REFERENCE_KEY)){
        this.fromAccountNumber = this.getRoutingParam(REFERENCE_KEY);
      }else{
        let accountList = this._beneficiaryListHelper.customerService?.getAccount('ALL');
        this.fromAccountNumber = accountList?accountList[0].accountNumber:undefined;
      }
        
      this.paymentType = this.getRoutingParam(PAYMENTTYPE);
      if (this.paymentType) this._beneficiaryListHelper.transferService.setTitle(['home', 'transfers'], true, this._beneficiaryListHelper.translate.instant('PAYMENTDETAILS.' + this.paymentType + "BENE"));
    }
    if (!this.paymentType) this.paymentType = 'all';
    this._commonService.showSpinner();
    this._beneficiaryService.getGrpByBeneList(this.paymentType).subscribe(res => {
      this.beneGrpList = res;
      this._commonService.hideSpinner();
      this._beneficiaryService.getBeneListByType('SWIFT').subscribe(res =>{
        this.swiftBeneList = res;
      });
      this._beneficiaryService.getBeneListByType('SEPA').subscribe(res =>{
        this.sepaBeneList = res;
      });
      this._beneficiaryService.getBeneListByType('INTBT').subscribe(res =>{
        this.intbtBeneList = res;
      });
      this._beneficiaryService.getBeneListByType('ACH').subscribe(res =>{
        this.achBeneList = res;
      });
    
      console.log("ach bene list: " + this.achBeneList);

      if (this.additionalDetails.fromNav != 'manageBene') {
        this.isTransfer = true;
        this._beneficiaryService.filter = 'all';
        this._beneficiaryService.getBeneListByType(this.paymentType,'all').subscribe(res=>{
          this.allBeneList = res;
        });
        this._beneficiaryService.filter = 'fav';
        this._beneficiaryService.getBeneListByType(this.paymentType,'fav').subscribe(res=>{
          this.favBeneList = res;
        });
      }
      else {
        this.isTransfer = false;
        this._beneficiaryService.filter = '';
         this._beneficiaryService.getBeneListByType('all').subscribe(res => {
          this.allBeneList = res;
        });
        this._beneficiaryService.getBeneListByType('fav').subscribe(res =>{
          this.favBeneList = res;
        });
      }
    });
  }

  getBeneKeyByType(paymentSystem) {
    switch (paymentSystem) {
      case 'INTBT': return 'beneAccount'
      case 'SWIFT': return 'beneSWIFT'
      // case 'SEPA': return 'beneSEPA',
      case 'ACH': return 'beneACH'
    }
  }
  onBeneSearch(searchString) {
    searchString = searchString.toLowerCase();
    // // ui filter
    // let beneKey = this.getBeneKeyByType(this.paymentType);
    // this.beneGrpList = [];
    // var filter = {
    //   "FilterExpression": "",
    //   "FilterCriteria": [
    //     {
    //       "columnName": "paymentSystem",
    //       "columnType": "String",
    //       "conditions": {
    //         "searchType": "equals",
    //         "searchText": this.paymentType
    //       }
    //     },
    //     {
    //       "columnName": "beneName",
    //       "columnType": "String",
    //       "conditions": {
    //         "searchType": "contains",
    //         "searchText": searchString
    //       }
    //     }
    //   ],
    //   "OrderCriteria": [
    //     {
    //       "columnName": "createdOn",
    //       "columnType": "Timestamp",
    //       "orderType": "desc"
    //     }
    //   ]
    // }
    // if (this.paymentType == 'SWIFT') {
    //   filter.FilterExpression = "C1AND(C2|C3|C4|C5)"
    //   let bankname = [{
    //     "columnName": beneKey + ':bankName',
    //     "columnType": "String",
    //     "conditions": {
    //       "searchType": "contains",
    //       "searchText": searchString
    //     }
    //   },
    //   {
    //     "columnName": beneKey + ':accNo',
    //     "columnType": "String",
    //     "conditions": {
    //       "searchType": "contains",
    //       "searchText": searchString
    //     }
    //   },
    //   {
    //     "columnName": beneKey + ':iban',
    //     "columnType": "String",
    //     "conditions": {
    //       "searchType": "contains",
    //       "searchText": searchString
    //     }
    //   }]
    //   bankname.forEach(element => {
    //     filter.FilterCriteria.push(element)
    //   })
    // }
    // else if (this.paymentType == 'SEPA') {
    //   filter.FilterExpression = "C1AND(C2|C3)"
    //   let iban = {
    //     "columnName": beneKey + ':iban',
    //     "columnType": "String",
    //     "conditions": {
    //       "searchType": "contains",
    //       "searchText": searchString
    //     }
    //   }
    //   filter.FilterCriteria.push(iban)
    // }
    // else if (this.paymentType == 'ACH') {
    //   filter.FilterExpression = "C1AND(C2|C3)"
    //   let iban = {
    //     "columnName": beneKey + ':iban',
    //     "columnType": "String",
    //     "conditions": {
    //       "searchType": "contains",
    //       "searchText": searchString
    //     }
    //   }
    //   filter.FilterCriteria.push(iban)
    // }
    // else if (this.paymentType == 'INTBT') {
    //   filter.FilterExpression = "C1AND(C2|C3)"
    //   let accno = {
    //     "columnName": beneKey + ':accNo',
    //     "columnType": "String",
    //     "conditions": {
    //       "searchType": "contains",
    //       "searchText": searchString
    //     }
    //   }
    //   filter.FilterCriteria.push(accno)
    // }
    // else {
    //   filter.FilterExpression = "C1",
    //     filter.FilterCriteria = [{
    //       "columnName": "beneName",
    //       "columnType": "String",
    //       "conditions": {
    //         "searchType": "contains",
    //         "searchText": searchString
    //       }
    //     }]
    // }
    let tempBeneList = []
    this.beneGrpList = [];
    this._beneficiaryService._beneList.forEach(res=>{
      if((!this.paymentType || this.paymentType=='all') && (res.beneName?.toLowerCase()?.includes(searchString) || res.beneAccount?.accNo?.includes(searchString) || res.beneACH?.accNo?.includes(searchString) || res.beneACH?.iban?.includes(searchString) || res.beneSWIFT?.bankName?.toLowerCase()?.includes(searchString) || res.beneSWIFT?.accNo?.includes(searchString))){
        tempBeneList.push(res);
      }
      if((this.paymentType=='fav' && res.favourite == '1') && (res.beneName?.toLowerCase()?.includes(searchString) || res.beneAccount?.accNo?.includes(searchString) || res.beneACH?.accNo?.includes(searchString) || res.beneACH?.iban?.includes(searchString) || res.beneSWIFT?.bankName?.toLowerCase()?.includes(searchString) || res.beneSWIFT?.accNo?.includes(searchString))){
        tempBeneList.push(res);
      }
      if((this.paymentType=='INTBT' && res.paymentSystem == 'INTBT') && (res.beneName?.toLowerCase()?.includes(searchString) || res.beneAccount?.accNo?.includes(searchString))){
        tempBeneList.push(res);
      }
      if((this.paymentType=='ACH' && res.paymentSystem == 'ACH') && (res.beneName?.toLowerCase()?.includes(searchString) || res.beneACH?.accNo?.includes(searchString) || res.beneACH?.iban?.includes(searchString) )){
        tempBeneList.push(res);
      }
      if((this.paymentType=='SWIFT' && res.paymentSystem == 'SWIFT') && (res.beneName?.toLowerCase()?.includes(searchString) || res.beneSWIFT?.bankName?.toLowerCase()?.includes(searchString) || res.beneSWIFT?.accNo?.includes(searchString))){
        tempBeneList.push(res);
      }
    })
    let sortArray = this._beneficiaryService.getSortedArray(tempBeneList, 'beneName')
    let groupArray = this._beneficiaryService.getGroupByArray(sortArray, 'beneName');
    this.beneGrpList = groupArray
    // this._beneficiaryService.searchBeneList(JSON.stringify(filter), this.paymentType).subscribe(res => {

    //   console.log("filter", res)
    // });

  }

  chooseFilter(e, filter) {
    (<HTMLInputElement>document.getElementById('beneSearch')).value = '';
    Array.from(document.getElementsByClassName('active')).forEach(element => {
      element.classList.remove('active');
    });
    e.target.classList.add('active');
    if (this.additionalDetails.fromNav == 'manageBene'){
      this.paymentType = filter;
      this.reloadBeneList(this.paymentType,'manageBene');
    }else {
      this._beneficiaryService.filter = filter;
      this.reloadBeneList(this.paymentType,filter);
    }
  }


  reloadBeneList(paymentType,filter) {
    this._commonService.showSpinner();
    if (this.additionalDetails.fromNav == 'manageBene') {
      this._beneficiaryService.reloadSearchBeneList(paymentType,filter).subscribe(res =>{
        this._commonService.hideSpinner();
        this.beneGrpList = res;
      })
    }      
    else {
      this._beneficiaryService.reloadSearchBeneList(paymentType,filter).subscribe(res =>{
        this._commonService.hideSpinner();
        this.beneGrpList = res;
      })
    }
  }

  onClickBackBtn() {
    if (this.popupMode) {
      this.dialogRef.close();
      return;
    }
    if (this.additionalDetails) {
      this._router.navigate(this.additionalDetails.closeNav, {
        queryParams: {
          "mode": 'add',
          additionalDetails: this.additionalDetails
        },
        queryParamsHandling: 'preserve',
      });
      return;
    }
    this._router.navigate(['home', 'transfers']);
  }

  protected doDestroy(): void {
    this.retailStock.headerRequired = true;
    this.retailStock.footerRequired = true;
  }




  addBene() {
    this.additionalDetails.fromNav = 'addBene';
    let navUrl = this.paymentType ? ['shell', 'transfers', 'bene-' + this.paymentType] : ['home', 'transfers', 'new-payment'];
    this._router.navigate(navUrl, {
      queryParams: {
        "mode": 'add',
        'additionalDetails': this.additionalDetails
      },
      queryParamsHandling: 'preserve',
      state: {
        title: this.paymentType,
        serviceCode: this.paymentType + 'BENEADD',
      }
    });
  }

  refreshBeneList(paymentType) {
    this._beneficiaryService.getGrpByBeneList(paymentType).subscribe(res =>{
      this.beneGrpList = res;
    })
  }

  createBene(){

    if(Object.keys(this.dialogRef).length) this.dialogRef.close();
    let additionalDetails = {
      closeNav: ['home', 'transfers'],
      fromNav : "addBene",
      hideFromAccount: true
    }
  
    let navUrl = this._commonService.isMobile() ? ['home', 'transfers', 'new-payment']:['home','transfers','new-bene'];
 
    this._router.navigate(navUrl, { 
      queryParams: {
        'type': 'addBene',
        'additionalDetails':additionalDetails,
        'paymentType': this.paymentType
      },
      queryParamsHandling: 'preserve',
      state: {
        "title" :"CONTEXTULAMENU.addBeneficiaryTitle",
        "serviceCode" : this.paymentType
      }
    });
  }

}
